import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type VariationFilterMessages = FiltersMessages & {
  filterByLabel: string;
  valueLabel: string;
  search: string;
  allOption: string;
  codeOption: string;
  descriptionOption: string;
  name: string;
  clearFilters: string;
  filter: string;
};

export const VARIATION_FILTER_MESSAGES: VariationFilterMessages = {
  codeOption: "Código",
  descriptionOption: "Nome",
  name: "Nome",
  clearFilters: "Limpar filtros",
  filter: "Filtrar",
  ...FILTER_MESSAGES,
};

export default VARIATION_FILTER_MESSAGES;
